module.exports = __webpack_public_path__ + "media/images/labs_test-8bd71dab48959a84356ce6bce266526b.jpg";